export class Question {
    constructor(id, stand_id, question, responses, response) {
        this.id = id
        this.stand_id = stand_id
        this.question = question
        this.responses = responses
        this.response = response
    }
}
